import axios from 'axios';
import type {
  // IGetLiveConciergePriceParams,
  IGetLiveConciergePriceRequest,
} from '@/app-package';
import { Country } from '@bb/automaton';
import { ViewingLevel } from 'Router/pages/SubscriptionsPaymentsPage';

/**
 * TODO: This entire thing is stubbed out waiting until KB-1142 is finished and merged.
 */
const getLiveConciergePrice = async ({
  calculationType,
  unitCount,
  country,
}: {
  calculationType: ViewingLevel;
  unitCount: number;
  country: Country | `${Country}`;
}) => {
  let config: IGetLiveConciergePriceRequest;
  // Set the currency depending on what country this request is from.
  let currency: string;
  if (country === 'CAN') {
    currency = 'CAD';
  } else {
    currency = 'USD';
  }

  // Send a different BillingProductName depending on if this is a brokerage or a user
  if (calculationType === 'org') {
    config = {
      url: `/whatever_url/?billingProductName=SHO-LCS-BROK&value=${unitCount}&currency=${currency}`,
      method: 'get',
    };
  } else if (calculationType === 'user') {
    config = {
      url: `/whatever_url/?billingProductName=SHO-LCS-SUB-USER&value=${unitCount}&currency=${currency}`,
      method: 'get',
    };
  } else {
    return null;
  }
  const { data } = await axios.request<number>(config);
  return data;
};

export default getLiveConciergePrice;
